import { NgClass, NgIf } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

@Component({
    selector     : 'fuse-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        `
            .fuse-confirmation-dialog-panel {

                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }

                button.mat-primary,
                .mat-mdc-unelevated-button.mat-primary,
                .mat-mdc-raised-button.mat-primary,
                .mat-mdc-flat-button.mat-primary,
                .mat-flat-button.mat-primary {
                    background-color: var(--fuse-primary, #2196f3) !important;
                    color: var(--fuse-on-primary, #ffffff) !important;
                }

                button.mat-primary:hover,
                .mat-mdc-unelevated-button.mat-primary:hover,
                .mat-mdc-raised-button.mat-primary:hover,
                .mat-mdc-flat-button.mat-primary:hover,
                .mat-flat-button.mat-primary:hover {
                    background-color: var(--fuse-primary-600, var(--fuse-primary)) !important;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class FuseConfirmationDialogComponent
{
    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig)
    {
    }

}
